import gql from 'graphql-tag';
import { CouponListItem } from '../fragments';

export default gql`
mutation updateCoupon (
    $id: ID!
    $name: String!
    $description: String
    $active_from: String!
    $active_to: String!
    $type: CouponType!
    $applied_to: CouponAppliedTo!
    $is_free_shipping: Boolean!
    $price_ranges: [CouponPriceRangeInput!]!
    $is_active: Boolean!
    $shipping_method_id: ID
    $payment_method_id: ID
    $usage_count: Int!
    $is_combinable: Boolean!
    $coupon_code_attributes: CouponCodeAttributes
    $codes: [String!]
    $products: [ID!]
) {
    updateCoupon (input: {
        id: $id,
        name: $name,
        description: $description,
        active_from: $active_from,
        active_to: $active_to,
        type: $type,
        applied_to: $applied_to,
        is_free_shipping: $is_free_shipping,
        price_ranges: $price_ranges,
        is_active: $is_active,
        shipping_method_id: $shipping_method_id,
        payment_method_id: $payment_method_id,
        usage_count: $usage_count,
        is_combinable: $is_combinable,
        coupon_code_attributes: $coupon_code_attributes,
        codes: $codes,
        products: $products
    }) {
        ...CouponListItem
    }
}
${CouponListItem}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/updateCoupon.ts